export const webKey = '218688a542ad78119f194fc7ed092ee9'
// 
export const securityJsCode = 'b66f162e7fdc3347ca76321e35dcee52'